import { render, staticRenderFns } from "./SoundSettingsDoorOpening.vue?vue&type=template&id=550233b0"
import script from "./SoundSettingsDoorOpening.vue?vue&type=script&lang=js"
export * from "./SoundSettingsDoorOpening.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports